import styled from 'styled-components/macro';
import { colorCoreGray1000Base } from '@yme/tokens/colors';
export const PropertyStyled = styled.span `
  position: relative;
  display: inline-block;

  ${({ hasPadding }) => hasPadding && 'padding-right: 20px;'}

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    bottom: 8px;
    width: 4px;
    height: 4px;
    margin-left: 10px;
    white-space: nowrap;
    border-radius: 50%;
    background-color: ${colorCoreGray1000Base};
  }
`;
